import ProjectSession from "../../../model2/project/project-session"
import {EntityType} from "../../../gd/const/item"
import {ItemDisplay} from "../../../model2/item/item-model"
import ProjectSessionCollection from "../../../model2/project/collection"
import {SelectParent_SectionType} from "../@const"
import {selectParent_getProjects} from "./get-projects"
import {SpaceProto} from "../../../model2/space/space-proto"
import Workspace from "../../../model2/space/workspaces/workspace";

// const debug = "SelectParentFilter"
const debug = false

const recursiveReset = (project:ProjectSession) => {
    project.treeDisplay = ItemDisplay.VISIBLE

    _.map(project.treeChildren, (childProject: ProjectSession) => {
        recursiveReset(childProject)
    })
}

const recursiveParentExpand = (project?:ProjectSession) => {
    if (!project) return

    project.treeIsExpandedProjectSelector = true

    recursiveParentExpand(project.treeParent)
}

const recursiveUpdateExpandState = (projects:ProjectSession[], selectedProjectsIds?: ID[]) => {
    _.map(projects, (project: ProjectSession) => {

        // expand all parent project for selected project to be visible
        if (selectedProjectsIds?.includes(project.id)) {
            recursiveParentExpand(project.treeParent)
        }

        project.treeIsExpandedProjectSelector = false
        recursiveUpdateExpandState(project.treeChildren, selectedProjectsIds)
    })
}

export const selectParent_recursiveUpdateExpandState = (currentSection?:SelectParent_SectionType | SpaceProto, selectedProjectsIds?: ID[], availableProjects?: ProjectSessionCollection) => {
    const projects = selectParent_getProjects(currentSection, {availableProjects})
    recursiveUpdateExpandState(projects, selectedProjectsIds)
}

const recursiveExpand = (project:ProjectSession) => {

    project.treeIsExpandedProjectSelector = true

    _.map(project.treeChildren, (childProject: ProjectSession) => {
        recursiveExpand(childProject)
    })
}


const recursiveFilter = (project:ProjectSession, parentFor?:EntityType, filterProjects?: ProjectSessionCollection) => {

    if (filterProjects && !filterProjects.get(project.id)) {
        project.treeDisplay = ItemDisplay.HIDDEN
    } else if (parentFor && !project.acl.canCreateEntity(parentFor)) {
        if (project.treeHasChildren) {
            project.treeDisplay = ItemDisplay.GHOST_VISIBLE
        } else {
            project.treeDisplay = ItemDisplay.HIDDEN
        }
    } else {
        debug && console.log(debug, 'recursiveFilter', project.name, "can create entity", parentFor)
    }

    _.map(project.treeChildren, (childProject: ProjectSession) => {
        recursiveFilter(childProject, parentFor, filterProjects)
    })

    if (project.treeIsHidden && project.treeHasVisibleChildren) {
        project.treeDisplay = ItemDisplay.GHOST_VISIBLE
    }
}

export function selectParent_filter(rootProjects: ProjectSession[], parentFor?:EntityType, availableProjects?: ProjectSessionCollection) {

    // reset workspaces projects treeDisplay
    _.map(gd.spaces.spacesWithProjects, (space: SpaceProto) => {
        const project = (space as Workspace).project
        if (project) {
            project.treeDisplay = ItemDisplay.VISIBLE
        }
    })

    _.map(rootProjects, (project: ProjectSession) => {
        recursiveReset(project)
    })

    _.map(rootProjects, (project: ProjectSession) => {
        recursiveFilter(project, parentFor, availableProjects)
    })

    debug && _.map(rootProjects, (project: ProjectSession) => {
        project.debugTreeDisplay()
    })
}

export function selectParent_searchAndFilter(queryString: string, parentFor:EntityType, availableProjects?: ProjectSessionCollection):ProjectSession[] {

    gd.session.projects.treeSearch(queryString, parentFor, availableProjects)

    const searchProjects : ProjectSession[] = gd.session.projects.treeRoots

    _.map(searchProjects, (project: ProjectSession) => {
        recursiveExpand(project)
    })

    debug && _.map(searchProjects, (project: ProjectSession) => {
        project.debugTreeDisplay()
    })

    let res: ProjectSession[] = []

    /**--- ADD temp project for Projects workspace [START]---**/
    const projectsWorkspaceProject = gd.spaces.projects.project
    // make Projects workspace project always ghost visible in search
    projectsWorkspaceProject.treeDisplay = ItemDisplay.GHOST_VISIBLE
    // make Projects workspace project always expanded by default in search
    projectsWorkspaceProject.treeIsExpandedProjectSelector = true

    // add all Projects workspace projects as treeChildren for Projects workspace project in search
    _.map(searchProjects, (project: ProjectSession) => {
        if (!project.isWorkspace) {
            projectsWorkspaceProject.treeChildren.push(project)
        }
    })

    // add Projects workspace project to results if it has any treeChildren
    if (!_.isEmpty(projectsWorkspaceProject.treeChildren)) {
        res.push(projectsWorkspaceProject)
    }

    const hasAnyVisibleChild = _.some(projectsWorkspaceProject.treeChildren, (projectSession: ProjectSession) => {
        return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(projectSession.treeDisplay)
    })

    if (!hasAnyVisibleChild) {
        projectsWorkspaceProject.treeDisplay = ItemDisplay.HIDDEN
    }
    /**--- ADD temp project for Projects workspace [END]---**/

    _.map(searchProjects, (project: ProjectSession) => {
        if (project.isWorkspace) {
            res.push(project)
        }
    })

    return res
}